<template>
    <footer class="w-100">
        <div class="container">
            <div class="footer-content">
                <div class="footer-left d-flex flex-column">
                    <h3>Foojan</h3>
                    <span>All copyright revised by foojan.com</span>
                </div>
                <div class="footer-links">
                    <a href="#">Home</a>
                    <a href="#">About us</a>
                    <a href="#">Terms & Conditions</a>
                    <a href="#">Privacy Policy</a>
                    <a href="#">Contact us</a>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
import { computed } from 'vue'
export default {
  setup () {
    const year = computed(() => new Date().getFullYear())
    return { year }
  }
}
</script>
